import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import axios from 'axios';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';

import Header from './components/sidebar/sidebar';
import { getUrl } from './components/planner/planner';

// Process Component
import Processes from './components/processes/processes-container';

// Product Components
import Products from './components/products/product-container';
import EditProductContainer from './components/products/edit-product-container';

// Scrap Components
import Scraps from './components/scraps/scrap-container';
import EditScrapContainer from './components/scraps/edit-scrap-container';

import ForcastContainer from './components/forcast/forcast-container';
import EmployeeForcast from './components/forcast/forcast-employees';

// Order Components
import OrdersContainer from './components/orders/orders-container';
import CustomerOrdersContainerWrapper from './components/orders/customer-orders-container-wrapper';
import CompanyOrdersContainerWrapper from './components/orders/company-orders-container-wrapper';
import EditOrderContainer from './components/orders/edit-order-container';

// Report Components
import OrdersDashboardContainer from './components/reports/orders-dashboard-container';
import ProductsDashboardContainer from './components/reports/products-dashboard-container';
import EmployeesDashboardContainer from './components/reports/employees-dashboard-container';

// Suggestion Components
import Suggestions from './components/suggestions/suggestions-container';
import EditSuggestionContainer from './components/suggestions/edit-suggestion-container';

// Employees Components
import Employees from './components/employees/employees-container';
import EmployeeContainer from './components/employees/view-employees-container';

// Traveller Components
import Travellers from './components/travellers/travellers-container';
import EditTravellerContainer from './components/travellers/edit-traveller-container';

import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

var parse = require('html-react-parser');

function App() {
	const [availableStatuses, setAvailableStatuses] = useState([]);
	const [availableManufacturers, setAvailableManufacturers] = useState([]);
	const [statuses, setStatuses] = useState(null);
	const [menuItems, setMenuItems] = useState([]);
	const [priority, setPriority] = useState(0);
	const [token, setToken] = useState(null);
	const [showLoginBox, setShowLoginBox] = useState(false);
	const [userPermissions, setUserPermissions] = useState([]);
	const [companyMenuItems, setCompanyMenuItems] = useState([]);
	const [customerMenuItems, setCustomerMenuItems] = useState([]);
	const [travellerStatusesCount, setTravellerStatusesCount] = useState([]);
	const [currentLoggedInUser, setCurrentLoggedInUser] = useState([]);
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const [loginUsername, setLoginUsername] = useState('');
	const [loginPassword, setLoginPassword] = useState('');
	const [usernameFailed, setUsernameFailed] = useState(false);
	const [batteryPackId, setBatteryPackId] = useState('');
	const [componentId, setComponentId] = useState('');
	const [cellId, setCellId] = useState('');
	const [chargerId, setChargerId] = useState('');
	const [accessoryId, setAccessoryId] = useState('');
	const [uncategorisedId, setUncategorisedId] = useState('');
	const [lastSyncedOrders, setLastSyncedOrders] = useState('');
	const [loginErrorMessage, setLoginErrorMessage] = useState('');
	const [sidebarRefresh, setSidebarRefresh] = useState(false);
	const [bookingCategoryIdEmployee, setBookingCategoryIdEmployee] = useState({id: null});
	const [bookingCategoryIdJobs, setBookingCategoryIdJobs] = useState({id: null});

	useEffect(() => {
		if(sidebarRefresh != true) {
			if(localStorage.getItem('userToken') || token !== null) {
				axios.get(getUrl() + '/wp-json/planner/v1/sidebar', { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} })
				.then(res => {
					setMenuItems(res.data.menu_items)
					// Products are hard coded temporarily.
					if(res.data.menu_items.products) {
						setBatteryPackId(res.data.menu_items.products.battery_pack)
						setComponentId(res.data.menu_items.products.component)
						setCellId(res.data.menu_items.products.cell)
						setChargerId(res.data.menu_items.products.charger)
						setAccessoryId(res.data.menu_items.products.accessory)
						setUncategorisedId(res.data.menu_items.products.uncategorised)	
					}
					setCompanyMenuItems(res.data.menu_items.companies)
					setLastSyncedOrders(res.data.last_synced_orders)
					setBookingCategoryIdEmployee(res.data.menu_items.bookings[0]);
					setBookingCategoryIdJobs(res.data.menu_items.bookings[1]);

					setUserPermissions(res.data.current_employee.capabilities)

					if(res.data.menu_items.customers) {
						setCustomerMenuItems(res.data.menu_items.customers);

						localStorage.setItem('customerMenuItems', JSON.stringify(res.data.menu_items.customers));
					}

					if(res.data.menu_items.companies) {
						setCompanyMenuItems(res.data.menu_items.companies);

						localStorage.setItem('companiesMenuItems', JSON.stringify(res.data.menu_items.companies));
					}

					setCurrentLoggedInUser(res.data.current_employee)
					localStorage.setItem('userCapabilities', JSON.stringify(res.data.current_employee.capabilities));
					localStorage.setItem('currentLoggedInUser', JSON.stringify(res.data.current_employee));
				})
				.catch(err => console.log(err));
			}

			if(!localStorage.getItem('userCapabilities') && !localStorage.getItem('userToken')) {
				setShowLoginBox(true);
			}	
		} else {
			setSidebarRefresh(false);
		}
	}, [token, localStorage.getItem('userToken')]);

	function closeSidebar() {
		setSidebarOpen(false);

		document.body.classList.add('sidebar-closed');
		document.body.classList.remove('sidebar-open');
	}

	function updateSidebar() {
		setSidebarRefresh(true);
	}

	function toggleSidebar() {
		setSidebarOpen(true);

		document.body.classList.add('sidebar-open');
		document.body.classList.remove('sidebar-closed');
	}

	function systemLogout() {
		setToken('');
	}

	async function systemLogin() {
		const [isLoggedIn] = await Promise.all([
			axios.post(getUrl() + '/wp-json/jwt-auth/v1/token', {
				"username" : loginUsername,
				"password" : loginPassword
			}).then(
				res => {
					setToken(res.data.token)
					localStorage.setItem('userToken', res.data.token);
					setUsernameFailed(false);
					setLoginErrorMessage('');
					setShowLoginBox(false);

					setLoginUsername('');
					setLoginPassword('');
				}
			).catch(err => {
				setLoginErrorMessage("<strong>Error: </strong>The username, email or password is incorrect.")

				if(err.response.data.message !== '') {
					setUsernameFailed(true);
				}
			})
		]);

		if(loginErrorMessage !== '') {
			setUsernameFailed(true);
		}

		if(isLoggedIn) {
			axios.get(getUrl() + '/wp-json/planner/v1/sidebar', { headers: {"Authorization" : `Bearer ${token}`} })
			.then(res => {
				setUserPermissions(res.data.current_employee.capabilities)
				localStorage.setItem('userCapabilities', JSON.stringify(res.data.current_employee.capabilities));
			})
			.catch(err => console.log(err));
		}
	}

	function redirection() {
		if(userPermissions.read_shop_orders || userPermissions.edit_shop_orders) {
			return 'jobs';
		} else if(userPermissions.edit_travellers || userPermissions.read_travellers) {
			return 'travellers';
		} else {
			return false;
		}
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		systemLogin();
	}

	return (
		<>
			<Dialog header="Login" visible={showLoginBox} style={{ width: '50vw' }} draggable={false} closable={false}>
				<form onSubmit={handleSubmit}>
					{
						usernameFailed && loginErrorMessage !== '' && (
							<p className="bg-danger text-white p-2">{parse(loginErrorMessage)}</p>
						)
					}
					<InputText value={loginUsername} onChange={(e) => {setLoginUsername(e.target.value); setUsernameFailed(false)}} placeholder="Username" className="w-100 mb-4" />
					<Password  value={loginPassword} onChange={(e) => {setLoginPassword(e.target.value); setUsernameFailed(false)}} placeholder="Password" className="w-100 mb-4 d-block" feedback={false} toggleMask />
					<Button type="submit" label="Submit" />
				</form>
			</Dialog>
			{
				localStorage.getItem('userToken') && localStorage.getItem('userCapabilities') && (
					<Router>
					{
						sidebarOpen && (<Button className="overlay" onClick={(e) => closeSidebar()}></Button>)
					}
					<div className="d-flex h-100">
						{
							(window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("test-planner") > -1) && getUrl() == 'https://planner-api.cellpacksolutions.co.uk' && (
								<div style={{position: 'fixed', bottom: '1rem', width: '100%', zIndex: '999999', display: 'flex', right: '1rem', justifyContent: 'end'}}>
									<span className="bg-danger text-white px-4 py-2">Live Data on test site</span>
								</div>
							)
						}
						<Header statuses={statuses} menuItems={menuItems} priority={priority} travellerStatusesCount={travellerStatusesCount} currentLoggedInUser={currentLoggedInUser} capabilities={userPermissions} customerMenuItems={customerMenuItems} companyMenuItems={companyMenuItems} sidebarOpen={sidebarOpen} updateSidebarClosed={closeSidebar} updateSidebarRefresh={updateSidebar} updateSystemLogout={systemLogout} />
						<div className="container-fluid my-0 mx-0 px-0">
							<Switch>
								<Route exact path="/">
									{
										redirection() === 'jobs' && (
											<Redirect to="/jobs/sales-order" />
										)
									}
									{
										redirection() === 'travellers' && (
											<Redirect to="/travellers/prepared" />
										)
									}
								</Route>
								<Route exact path="/reports">
									<OrdersDashboardContainer />
								</Route>
								<Route exact path="/logout">
								</Route>
								<Route exact path="/reports/orders">
									<OrdersDashboardContainer title="Report: Orders" />
								</Route>
								<Route exact path="/reports/products">
									{
										batteryPackId && componentId && cellId && (
											<ProductsDashboardContainer title="Report: Products" batteryPackId={batteryPackId} componentId={componentId} cellId={cellId} />
										)
									}
								</Route>
								<Route exact path="/reports/employees">
									<EmployeesDashboardContainer title="Report: Employees" />
								</Route>
								<Route exact path="/jobs/sales-order">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="Sales Orders" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: Sales Orders" availableStatuses={availableStatuses} status="sales-orders" />
								</Route>
								<Route path="/customers">
									<CustomerOrdersContainerWrapper currentLoggedInUser={currentLoggedInUser} pageTitle="Technolog" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} lastSyncedOrders={lastSyncedOrders} title="Jobs: Technolog" accountCode="T011" availableStatuses={availableStatuses} status="sales-orders" />
								</Route>
								<Route path="/jobs/completed">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="Completed Jobs" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: Completed" availableStatuses={availableStatuses} status="completed" singleStatus="true" />
								</Route>
								<Route exact path="/jobs/cancelled">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="Cancelled Jobs" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: Cancelled" availableStatuses={availableStatuses} status="cancelled" singleStatus="true" />
								</Route>
								<Route exact path="/jobs/ready-to-ship">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="Ready to Ship Jobs" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: Ready to Ship" availableStatuses={availableStatuses} status="ready-to-ship" singleStatus="true" />
								</Route>
								<Route exact path="/jobs/pro-forma">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="Pro-Formas" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: Pro-Formas" availableStatuses={availableStatuses} status="pro-formas" />
								</Route>
								<Route exact path="/jobs/on-hold">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="On Hold Jobs" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: On Hold" availableStatuses={availableStatuses} status="on-hold" singleStatus="true" />
								</Route>
								<Route exact path="/jobs/in-production">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="In Production Jobs" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: In Production" availableStatuses={availableStatuses} status="in-production" singleStatus="true" />
								</Route>
								<Route exact path="/jobs/priority">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="Priority Jobs" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: Priority" availableStatuses={availableStatuses} status="priority" />
								</Route>
								<Route exact path="/jobs/kitted">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="Kitted Jobs" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: Kitted" availableStatuses={availableStatuses} status="kitted" />
								</Route>
								<Route exact path="/jobs/companies">
									<OrdersContainer currentLoggedInUser={currentLoggedInUser} pageTitle="Companies" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Jobs: All Company" availableStatuses={availableStatuses} />
								</Route>
								<Route path="/companies">
									<CompanyOrdersContainerWrapper currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} lastSyncedOrders={lastSyncedOrders} title="Jobs: Cell Pack Solutions" availableStatuses={availableStatuses} status="sales-orders" />
								</Route>
								<Route path="/job"> 
									<EditOrderContainer currentLoggedInUser={currentLoggedInUser} capabilities={userPermissions} availableStatuses={availableStatuses} updateSidebarOpened={toggleSidebar} />
								</Route>
								<Route path="/products" exact>
									<Products currentLoggedInUser={currentLoggedInUser} pageTitle="Products" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Products" showTime={true} />
								</Route>
								<Route path="/products/battery-packs">
									{
										batteryPackId !== '' && (
											<Products showTime={true} currentLoggedInUser={currentLoggedInUser} pageTitle="Battery Packs" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Products: Battery Packs" singleCategory={true} category={16} />
										)
									}
								</Route>
								<Route path="/products/cells">
									{
										cellId !== '' && (
											<Products showTime={true} currentLoggedInUser={currentLoggedInUser} pageTitle="Cells" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Products: Cells" singleCategory={true} hideTime={true} category={18}  />
										)
									}
								</Route>
								<Route path="/products/components">
									{
										componentId !== '' && (
											<Products showTime={true} currentLoggedInUser={currentLoggedInUser} pageTitle="Components" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Products: Components" singleCategory={true} hideTime={true} category={17} />
										)
									}
								</Route>
								<Route path="/products/accessories">
									{
										accessoryId !== '' && (
											<Products showTime={true} currentLoggedInUser={currentLoggedInUser} pageTitle="Accessories" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Products: Accessories" singleCategory={true} hideTime={true} category={44} />
										)
									}
								</Route>
								<Route path="/products/uncategorised">
									{
										uncategorisedId !== '' && (
											<Products showTime={true} currentLoggedInUser={currentLoggedInUser} pageTitle="Uncategorised" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Products: Uncategorised" singleCategory={true} hideTime={true} category={15} />
										)
									}
								</Route>
								<Route path="/products/chargers">
									{
										chargerId !== '' && (
											<Products showTime={true} currentLoggedInUser={currentLoggedInUser} pageTitle="Chargers" updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Products: Chargers" singleCategory={true} hideTime={true} category={43} />
										)
									}
								</Route>
								<Route path="/product">
									<EditProductContainer currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} availableManufacturers={availableManufacturers} />
								</Route>
								<Route exact path="/travellers">
									<Travellers currentLoggedInUser={currentLoggedInUser} pageTitle="Travellers" updateSidebarOpened={toggleSidebar} title="Travellers" capabilities={userPermissions} />
								</Route>
								{
									bookingCategoryIdJobs && (
										<Route exact path="/bookings/travellers">
											<ForcastContainer currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} bookingCategoryId={bookingCategoryIdJobs.id} />
										</Route>
									)
								}
								{
									bookingCategoryIdEmployee && (
										<Route exact path="/bookings/employees">
											<EmployeeForcast currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} employeeCategoryId={bookingCategoryIdEmployee.id} />
										</Route>
									)
								}
								<Route path="/travellers/inputted">
									<Travellers currentLoggedInUser={currentLoggedInUser} pageTitle="Inputted Travellers" updateSidebarOpened={toggleSidebar} title="Travellers: Inputted" capabilities={userPermissions} status="inputted" />
								</Route>
								<Route path="/travellers/prepared">
									<Travellers currentLoggedInUser={currentLoggedInUser} pageTitle="Prepared Travellers" updateSidebarOpened={toggleSidebar} title="Travellers: Prepared" capabilities={userPermissions} status="prepared" />
								</Route>
								<Route path="/travellers/in-progress">
									<Travellers currentLoggedInUser={currentLoggedInUser} pageTitle="In Progress Travellers" updateSidebarOpened={toggleSidebar} title="Travellers: In Progress" capabilities={userPermissions} status="in-progress" />
								</Route>
								<Route path="/travellers/on-hold">
									<Travellers currentLoggedInUser={currentLoggedInUser} pageTitle="On Hold Travellers" updateSidebarOpened={toggleSidebar} title="Travellers: On Hold" capabilities={userPermissions} status="on-hold" />
								</Route>
								<Route path="/travellers/cancelled">
									<Travellers currentLoggedInUser={currentLoggedInUser} pageTitle="Cancelled Travellers" updateSidebarOpened={toggleSidebar} title="Travellers: Cancelled" capabilities={userPermissions} status="cancelled" />
								</Route>
								<Route path="/travellers/completed">
									<Travellers currentLoggedInUser={currentLoggedInUser} pageTitle="Completed Travellers" updateSidebarOpened={toggleSidebar} title="Travellers: Completed" capabilities={userPermissions} status="completed" />
								</Route>
								<Route path="/processes">
									<Processes updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Processes" />
								</Route> 
								<Route exact path="/scraps">
									<Scraps currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Scraps" />
								</Route>
								<Route path="/scraps/replaced">
									<Scraps currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} status="replaced" title="Scraps: Replaced" />
								</Route>
								<Route path="/scraps/reported">
									<Scraps currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} status="reported" title="Scraps: Reported" />
								</Route>
								<Route path="/scrap">
									<EditScrapContainer currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Scraps" />
								</Route>
								<Route exact path="/suggestions">
									<Suggestions currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Suggestions" />
								</Route>
								<Route path="/suggestions/reported">
									<Suggestions currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Suggestions: Reported" status="reported" />
								</Route>
								<Route path="/suggestions/approved">
									<Suggestions currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Suggestions: Approved" status="approved" />
								</Route>
								<Route path="/suggestions/dismissed">
									<Suggestions currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Suggestions: Dismissed" status="dismissed" />
								</Route>
								<Route path="/employees/account-manager">
									<Employees updateSidebarOpened={toggleSidebar} title="Employees : Account Manager" role="account_manager" />
								</Route>
								<Route path="/employees/production-manager"> 
									<Employees updateSidebarOpened={toggleSidebar} title="Employees : Production Manager" role="production_manager" />
								</Route>
								<Route path="/employees/production-operator">
									<Employees updateSidebarOpened={toggleSidebar} title="Employees : Production Operator" role="production_operator" />
								</Route>
								<Route path="/employees/production-kitter">
									<Employees updateSidebarOpened={toggleSidebar} title="Employees : Production Kitter" role="production_kitter" />
								</Route>
								<Route path="/employees/">
									<Employees updateSidebarOpened={toggleSidebar} title="Employees" />
								</Route>
								<Route path="/employee">
									<EmployeeContainer currentLoggedInUser={currentLoggedInUser} capabilities={userPermissions} updateSidebarOpened={toggleSidebar} title="Employee" bookingEmployeeId={bookingCategoryIdEmployee} />
								</Route>
								<Route path="/suggestion">
									<EditSuggestionContainer currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} title="Suggestion" />
								</Route>
								<Route path="/traveller">
									<EditTravellerContainer currentLoggedInUser={currentLoggedInUser} updateSidebarOpened={toggleSidebar} capabilities={userPermissions} />
								</Route>
							</Switch>
						</div>
					</div>
				</Router>
				)
			}
		</>
 );
}
export default App;